/**
 * Canonical French street-type names that may appear at the start of an address
 * (after the optional street number). Variants/abbreviations are pulled from
 * ADDRESS_ABBREVIATIONS at runtime. We don't include items like 'saint',
 * 'premier', 'bâtiment' on purpose: those are name modifiers, not street types.
 */
export const STREET_TYPE_CANONICALS = [
  'rue',
  'allée',
  'avenue',
  'boulevard',
  'centre commercial',
  'chaussée',
  'chemin',
  'cité',
  'cours',
  'domaine',
  'esplanade',
  'faubourg',
  'galerie',
  'hameau',
  'impasse',
  'lotissement',
  'passage',
  'place',
  'promenade',
  'quai',
  'quartier',
  'rond-point',
  'route',
  'route départementale',
  'route nationale',
  'ruelle',
  'sentier',
  'square',
  'traverse',
  'voie',
  'zone artisanale',
  'zone industrielle',
]
